import React from 'react'
import Eula from '../eula'

const EulaEs = () => {
    return <Eula languageCode="es" />
}

export default EulaEs
